import { http } from "../http/Http";
import { WorkflowProcessStatus } from "../models/WorkflowProcessStatus";
import { ServiceResponse } from "../models/ServiceResponse";

export class WorkflowProcessStatusService {

    getWorkflowProcessStatuses = async (): Promise<ServiceResponse<WorkflowProcessStatus[]>> => {
        const { data } = await http.get<ServiceResponse<WorkflowProcessStatus[]>>("WorkflowProcessStatus/GetAll");
        return data;
    };

}